module.exports = __webpack_public_path__ + "static/img/作品91.545cde1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/作品91.png
// module id = UfuB
// module chunks = 1